<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-date-picker
          v-model="selectedDate"
          :allowed-dates="isDateAllowed"
          color="primary"
          no-title
          locale="pt-BR"
          width="450"
        ></v-date-picker>
      </v-col>
      <v-col cols="12" md="4">
        <ul>
          <v-radio-group v-model="selectedHour">
            <v-radio
              v-for="(slot, index) in schedulesForSelectedDate"
              :key="index"
              :label="`${slot.hour} - ${slot.to}`"
              :value="slot"
              style="margin-top: 1vw"
            ></v-radio>
          </v-radio-group>
        </ul>
        <p v-if="schedulesForSelectedDate.length === 0">Escolha um horário</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "custom-datepicker",
  props: {
    horarios: {
      type: Array,
    },
  },
  data() {
    return {
      selectedDate: null,
      selectedHour: null,
    };
  },
  computed: {
    availableWeekDays() {
      return [
        ...new Set(
          this.horarios
            .map((slot) => this.normalizeWeekDay(slot.weekDay))
            .filter((weekDay) => weekDay !== null)
        ),
      ];
    },
    availableDates() {
      return [
        ...new Set(
          this.horarios
            .map((slot) => slot.date)
            .filter((date) => typeof date === "string" && date.length > 0)
        ),
      ];
    },
    schedulesForSelectedDate() {
      if (!this.selectedDate) return [];

      return this.horarios
        .filter((slot) => {
          if (slot.date) {
            return slot.date === this.selectedDate;
          }

          return (
            this.normalizeWeekDay(slot.weekDay) ===
            this.getWeekDay(this.selectedDate)
          );
        })
        .sort((a, b) => a.hour.localeCompare(b.hour));
    },
  },
  methods: {
    parseDate(dateStr) {
      const [y, m, d] = dateStr.split("-");
      return new Date(y, m - 1, d);
    },
    getWeekDay(dateStr) {
      return this.parseDate(dateStr).getDay();
    },
    normalizeWeekDay(weekDay) {
      const numericWeekDay = Number(weekDay);

      if (Number.isNaN(numericWeekDay)) {
        return null;
      }

      return numericWeekDay === 7 ? 0 : numericWeekDay;
    },
    isDateAllowed(dateStr) {
      const date = this.parseDate(dateStr);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (date <= today) return false;

      if (this.availableDates.length > 0) {
        return this.availableDates.includes(dateStr);
      }

      return this.availableWeekDays.includes(this.getWeekDay(dateStr));
    },
    formatDate(dateStr) {
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      return new Date(dateStr).toLocaleDateString("pt-BR", options);
    },
    getData() {
      return {
        selectedDate: this.selectedDate,
        selectedHour: this.selectedHour,
      };
    },
  },
  watch: {
    horarios: {
      immediate: true,
      handler(nextSlots) {
        this.selectedHour = null;

        const dates = [
          ...new Set(
            (nextSlots || [])
              .map((slot) => slot.date)
              .filter((date) => typeof date === "string" && date.length > 0)
          ),
        ].sort();

        if (dates.length === 0) {
          this.selectedDate = null;
          return;
        }

        if (!dates.includes(this.selectedDate)) {
          [this.selectedDate] = dates;
        }
      },
    },
    selectedDate() {
      this.selectedHour = null;
    },
  },
};
</script>
